import React from "react"
import styles from "./TermStep.module.css"
import {TermStepItem} from "./TermStepItem"
import {AcademicPlans} from "types/academicPlans"
import moment from "moment"

type Props = {
    studentId: number
    terms: AcademicPlans.TermCourseStats[]
    onChangeActiveTerm: (term: AcademicPlans.TermCourseStats) => void
}

export function TermStep(props: Props) {
    const {terms, onChangeActiveTerm} = props
    const currentTermIndex = terms.reduce((currentIdx, term, index) => {
        if (moment().isSameOrAfter(term.startDate)) {
            currentIdx = index
        }
        if (index === terms.length - 1 && currentIdx === -1 && moment().isAfter(term.endDate)) {
            return terms.length
        }
        return currentIdx
    }, -1)

    const isAfterTermIdx = terms.reduce((currentIdx, term, index) => {
        if (
            moment().isAfter(term.endDate) &&
            (!terms[index + 1]?.startDate ||
                (terms[index + 1]?.startDate && moment().isBefore(terms[index + 1]?.startDate)))
        ) {
            currentIdx = index
        }
        if (index === terms.length - 1 && currentIdx === -1 && moment().isAfter(term.endDate)) {
            return terms.length
        }
        return currentIdx
    }, -1)
    return (
        <div className={styles.wrap}>
            {terms.map((term, index) => (
                <TermStepItem
                    isCompleted={currentTermIndex > index || isAfterTermIdx >= index}
                    isAfterTerm={isAfterTermIdx === index}
                    onChangeActiveTerm={onChangeActiveTerm}
                    key={`${term.id}_${index}`}
                    index={index}
                    term={term}
                    isLastCompletedItem={currentTermIndex === index}
                />
            ))}
        </div>
    )
}
